// src/pages/UserManagement/index.tsx
import React, { useState, useEffect } from 'react';
import { Box, Container, Paper } from '@mui/material';
import UserManagementComponent from './UserManagementComponent';
import UserDetailPanel from './UserDetailPanel';
import { useParams } from 'react-router-dom';
import AdminInviteDialog from '../SuperAdmin/AdminInviteDialog';

interface UserManagementProps {
  showInviteDialog?: boolean;
}

const UserManagement: React.FC<UserManagementProps> = ({ showInviteDialog = false }) => {
  const { userId } = useParams();
  const [inviteDialogOpen, setInviteDialogOpen] = useState(showInviteDialog);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Effect to handle the prop change
  useEffect(() => {
    if (showInviteDialog) {
      setInviteDialogOpen(true);
    }
  }, [showInviteDialog]);

  // Function to open invite dialog - this will be passed to the UserManagementComponent
  const handleOpenInviteDialog = () => {
    setInviteDialogOpen(true);
  };

  // This tells the UserManagementComponent to refresh its data
  const triggerRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flexGrow: 1 }}>
          <UserManagementComponent 
            onInviteClick={handleOpenInviteDialog} 
            refreshTrigger={refreshTrigger}
          />
        </Box>
        
        {userId && userId !== 'invite' && (
          <Box sx={{ width: '35%', ml: 3 }}>
            <Paper sx={{ p: 3, position: 'sticky', top: '90px' }}>
              <UserDetailPanel userId={userId} />
            </Paper>
          </Box>
        )}
      </Box>

      {/* Use the AdminInviteDialog for system-level invitations */}
      <AdminInviteDialog
        open={inviteDialogOpen}
        onClose={(refreshData) => {
          setInviteDialogOpen(false);
          if (refreshData) triggerRefresh();
        }}
      />
    </Container>
  );
};

export default UserManagement;